import React, { Component } from 'react';
import Box from 'grommet/components/Box';
import Heading from 'grommet/components/Heading';
import Button from 'grommet/components/Button';
import Close from 'grommet/components/icons/base/Close';
import {acceptwlsl,rejectwlsl } from '../../State/actions/sessions';
import { connect } from 'react-redux';
import Paragraph from 'grommet/components/Paragraph';

class Notifications extends Component {
  constructor()
  {
    super();
    this.getText = this.getText.bind(this);
    this.accept = this.accept.bind(this);
  }

reject(id)
{
  var accptedUser = this.props.data.filter((item)=>{   
     if(item.SourceID === id)
     return item;
  });
  this.props.onRejectwlsl(accptedUser[0].ID);
  
}

accept(id)
{
  
  var accptedUser = this.props.data.filter((item)=>{   
     if(item.SourceID === id)
     return item;
    
});

  this.props.onAcceptwlsl(accptedUser[0].ID);
}

componentWillReceiveProps(nextProps) {
  if(this.props.data!==nextProps.data || this.responseMsg!==nextProps.responseMsg)
  {
    this.setState({});
  }
}

getText(id)
{
  var text =  id +' wants to share ';
  var workloads = this.props.data.filter((item)=>{
    if(item.SourceID === id && item.SubType=='Workload')
    {
      return item;
    }
  });
  var solutions = this.props.data.filter((item)=>{
    if(item.SourceID === id && item.SubType=='Solution')
    {
      return item;
    }
  });

if(workloads.length == 1)
{
text+='a workload ';
}else if(workloads.length > 1)
{
  text+='workloads ';
}
if (workloads.length >0 && solutions.length>0) {
	text+='and ';
}

if(solutions.length == 1)
{
text+='a solution ';
}else if(solutions.length > 1)
{
  text+='solutions ';
}
  
  return text+'with you.  Do you want to allow?';
}
render(){
var allIds=[];
this.props.data.map((item)=>{   
    if (allIds.indexOf(item.SourceID) === -1) {
    	allIds.push(item.SourceID);
    }
});

var notificatinos = allIds.map((item)=>{
  var textContent = this.getText(item);
  return <Box margin='small' pad='small' colorIndex='light-2'>
        <Heading tag="h5" strong={true}>{textContent}</Heading>
        <Box direction='row' style={{alignSelf: "flex-end"}}><Button label='Accept' style={{color:'#01a982'}} plain={true} 
        onClick={(e)=> 
         this.accept(item)
        }></Button>
        <Button critical={true}  plain={true} label='Reject' style={{color:'#f04953'}} onClick={(e)=>{this.reject(item)}}></Button></Box></Box>
});

    return(
   
    <Box direction="column" margin="none" pad="none" style={{ width: '100%', height: '100%' }} >
        <Box direction="row" colorIndex="neutral-1" margin="none" pad="small" separator="bottom">
          <Box direction="row" margin="none" pad="none" align='start' style={{ width: '96%' }}> 
            <Heading tag="h4" strong={true} style={{ marginBottom: '0px', color: '#01a982' }}>Notifications</Heading>
          </Box>
          <Box direction="row" margin="none" pad="none" align='start' alignContent="start"  >
            <Close size='small' colorIndex='light-2' className="CloseIconStyle" onClick={this.props.close} />
          </Box>
        </Box>
        <Box>{notificatinos.length>0 ? notificatinos :<Box style={{alignItems:'center'}}><Paragraph size='medium'>You do not have any notifications.</Paragraph></Box>}</Box>       
    </Box>
    );
}
}


const mapStateToProps = (state) => {
  return {
    data:state.sessions.notifications,
    responseMsg:state.sessions.responseMsg
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onAcceptwlsl: (data) => {
      dispatch(acceptwlsl(data));
    },
    onRejectwlsl: (data) => {
      dispatch(rejectwlsl(data));
    } 
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Notifications);




// WEBPACK FOOTER //
// ./src/SizingEngineUI/SizingEngineCommonScreens/Notifications.js